var _defs, _rect, _rect2, _rect3, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew278({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3.46,
    y: 3.09,
    width: 9.08,
    height: 4.09,
    transform: "translate(16 10.27) rotate(180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 8,
    y: 5.14,
    width: 4.54,
    height: 1.9,
    transform: "translate(20.54 12.17) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 3.46,
    y: 3.24,
    width: 4.54,
    height: 1.9,
    transform: "translate(11.46 8.37) rotate(180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 2.46,
    r: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.39,14.06V10.34h2.2v.44H.79v1.14H2.48v.44H.79v1.26H2.66v.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.91,14.06l1.18-1.94-1-1.78h.48l.56,1a4.24,4.24,0,0,1,.24.46c.07-.14.15-.28.24-.43l.62-1h.43L4.56,12.09l1.15,2h-.5l-.77-1.32c0-.08-.09-.16-.13-.25l-.15.28L3.4,14.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.28,14.06V10.34H9.33v.44H7.68v1.15H9.11v.44H7.68v1.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.85,14.06V10.34h.4v1.53h1.59V10.34h.4v3.72h-.4V12.31H10.25v1.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.92,14.06V10.34h1.36a1.37,1.37,0,0,1,.62.11.73.73,0,0,1,.33.34,1.14,1.14,0,0,1,.13.57,1,1,0,0,1-.22.68,1,1,0,0,1-.64.33,1,1,0,0,1,.26.21,2.59,2.59,0,0,1,.32.47l.53,1h-.5l-.41-.77a4.85,4.85,0,0,0-.36-.61.61.61,0,0,0-.23-.21.7.7,0,0,0-.32-.06h-.46v1.65ZM13.33,12h.87a1.23,1.23,0,0,0,.43-.06.6.6,0,0,0,.23-.22.64.64,0,0,0,.09-.34.57.57,0,0,0-.17-.44.66.66,0,0,0-.49-.17h-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew278);
export default __webpack_public_path__ + "static/media/Symbolpack_New_278.b107ef394fdbdf1931e3727cc48634f4.svg";
export { ForwardRef as ReactComponent };